import { Link } from 'react-router-dom'
import { CreditCard, Landmark, Coins } from 'lucide-react'
import { useClub } from '@/lib/hooks'
import { Button } from '@/components/ui/button'

export function PaymentsPage() {
  const { data: club } = useClub()
  if (!club) return null
  return (
    <div className="py-24">
      <div className="container-narrow">
        <div className="mb-12 max-w-2xl">
          <span className="eyebrow">Registration &amp; Program Payments</span>
          <h1 className="mt-3 font-display text-display-2 uppercase">Payments.</h1>
          <p className="mt-4 text-muted-foreground">
            Cosmos F.C. accepts payments via PayPal, check, and cash. For registration fees, use the appropriate PayPal link below or contact the office to arrange another method.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          <div className="rounded-2xl border border-border bg-card p-6">
            <CreditCard className="h-8 w-8 text-cosmos-green mb-3" />
            <h3 className="font-display text-xl uppercase">PayPal</h3>
            <p className="text-sm text-muted-foreground mt-2">Instant online payment. Receipts emailed automatically.</p>
            <Button asChild variant="gold" className="mt-4">
              <a href={club.payments.paypalPayNow} target="_blank" rel="noreferrer">Pay Now →</a>
            </Button>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <Landmark className="h-8 w-8 text-cosmos-green mb-3" />
            <h3 className="font-display text-xl uppercase">Check</h3>
            <p className="text-sm text-muted-foreground mt-2">Mail checks payable to <strong>Cosmos F.C.</strong> to our P.O. box.</p>
            <div className="mt-4 rounded-md bg-muted/40 p-3 text-sm">
              {club.address.line1}<br />
              {club.address.city}, {club.address.state} {club.address.zip}
            </div>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <Coins className="h-8 w-8 text-cosmos-green mb-3" />
            <h3 className="font-display text-xl uppercase">Cash</h3>
            <p className="text-sm text-muted-foreground mt-2">Bring cash to any training session — receipts issued on the spot.</p>
            <Button asChild variant="outline" className="mt-4"><Link to="/contact">Contact office</Link></Button>
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-dashed border-border p-6">
          <h4 className="font-display text-lg uppercase mb-2">What registration fees cover</h4>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Fees fund professional coaches, US Soccer &amp; association fees, insurance, league fees, admin &amp; staff, equipment, fields, lights, referees, camps, goalkeeper training, clinics, and college recruitment support.
          </p>
        </div>
      </div>
    </div>
  )
}
